import { format } from "d3-format";
import React from "react";
import { Chart, ChartCanvas } from "@react-financial-charts/core";
import { XAxis, YAxis } from "@react-financial-charts/axes";
import { ema, forceIndex } from "@react-financial-charts/indicators";
import { discontinuousTimeScaleProviderBuilder } from "@react-financial-charts/scales";
import {
  StraightLine,
  AlternatingFillAreaSeries,
} from "@react-financial-charts/series";
import { SingleValueTooltip } from "@react-financial-charts/tooltip";
import { withDeviceRatio, withSize } from "@react-financial-charts/utils";
import { nFormatter } from "../../../utils/utils";

const EFIndicator = ({
  height,
  ratio,
  width,
  initialData,
  xAccessor,
  displayXAccessor,
  xScale,
  xExtents,
}) => {
  const formatedData = initialData && initialData.map((item) => ({
    ...item,
    date: new Date(item.timestamp),
  }));

  const xScaleProvider =
    discontinuousTimeScaleProviderBuilder().inputDateAccessor((d) => d.date);

  const fi = forceIndex()
    .merge((d, c) => {
      d.fi = d.EFI;
    })
    .accessor((d) => d.fi);

  const fiEMA13 = ema()
    .id(1)
    .options({ windowSize: 13, sourcePath: "fi" })
    .merge((d, c) => {
      d.fiEMA13 = c;
    })
    .accessor((d) => d.fiEMA13);

  const calculatedData = fiEMA13(fi(formatedData));

  const { data } = xScaleProvider(calculatedData);

  const yAccessor = fiEMA13.accessor();

  const calculateOptimalTicks = (data, chartHeight) => {
    const dataRange =
      Math.max(...data.map((item) => item.EFI)) -
      Math.min(...data.map((item) => item.EFI));
    let baseTickNumber = Math.floor(chartHeight / 50);
    const rangeAdjustment = Math.ceil(dataRange / 100);
    const finalTickNumber = baseTickNumber + rangeAdjustment;
    return Math.max(finalTickNumber, 3);
  };
  const optimalTicks = calculateOptimalTicks(calculatedData, height);

  return (
    <ChartCanvas
      height={height}
      ratio={ratio}
      width={width}
      data={data}
      displayXAccessor={displayXAccessor}
      seriesName="Data"
      xScale={xScale}
      xAccessor={xAccessor}
      xExtents={xExtents}
      disableZoom={true}
      disablePan={true}
      disableInteraction={true}
    >
      <Chart id={1} yExtents={yAccessor}>
        <XAxis strokeStyle={"#8d8d8d"}
          tickStrokeStyle={"#8d8d8d"} />
        {/* <YAxis tickFormat={(value) => nFormatter(value, 2)} />
         */}
        <YAxis strokeStyle={"#8d8d8d"}
          tickStrokeStyle={"#8d8d8d"} tickFormat={format(".2f")} ticks={5} />

        <XAxis
          showTicks={false}
          xZoomHeight={1}
          tickPadding={0}
          axisAt={"top"}
          orient={"top"}
          strokeStyle={"#8d8d8d"}
          tickStrokeStyle={"#8d8d8d"}
        />
        <YAxis
          showTicks={false}
          yZoomWidth={1}
          tickPadding={0}
          axisAt={"left"}
          orient={"left"}
          strokeStyle={"#8d8d8d"}
          tickStrokeStyle={"#8d8d8d"}
        />
        <AlternatingFillAreaSeries
          yAccessor={yAccessor}
          baseAt={0}
          fillStyle={{ top: "#709a76", bottom: "#b07673" }}
          strokeStyle={{ top: "#24422b", bottom: "#5a4848" }}
        />
        <StraightLine yValue={0} lineDash="Solid" />
      </Chart>
    </ChartCanvas>
  );
};

export default EFIndicator;
